import React from 'react';
import PropTypes from "prop-types";

import { compose, bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from 'actions';


// react component for creating dynamic tables
import ReactTable from 'react-table';
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// @material-ui/icons
import Assignment from "@material-ui/icons/Assignment";
// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import CardHeader from "components/Card/CardHeader.jsx";

import { cardTitle } from "assets/jss/material-dashboard-pro-react.jsx";
import { reactTableDefaultProps } from 'helpers/reactTable';

import OrgSelector from "views/Orgs/OrgSelector.jsx";
import SweetAlert from 'react-bootstrap-sweetalert/lib/dist/SweetAlert';

const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px",
    fontWeight: "bold"
  }
};

class FormManager extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      alert: null,
    };
  }

  componentDidMount() {
    if (!this.props.forms) {
      this.props.getFormsAction();
    }
  }

  render() {
    const { classes } = this.props;
    const forms = this.props.forms ? this.props.forms : [];
    return (
      <GridContainer>
        <OrgSelector color={this.props.color} />
        <GridItem xs={12}>
          <Card>
            <CardHeader color="primary" icon>
              <CardIcon color="primary">
                <Assignment />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>서식 관리</h4>
            </CardHeader>
            <CardBody>
              <ReactTable
                {...reactTableDefaultProps}
                data={forms}
                columns={[
                  {
                    id: '영역',
                    Header: "영역",
                    accessor: d => d.data().영역
                  },
                  {
                    id: '목표',
                    Header: "목표",
                    accessor: d => `${d.data().목표}(${d.data().영역})`,
                    Cell: row => <div style={{ textAlign: "left" }}>{row.value}</div>
                  },
                  {
                    id: '서식번호',
                    Header: "서식번호",
                    accessor: d => d.data().서식,
                    sortMethod: (a, b) => {
                      const ta = a.replace("_", "").split("-");
                      const tb = b.replace("_", "").split("-");

                      if (ta[0] === tb[0]) {
                        return parseInt(ta[1] | 0) > parseInt(tb[1] | 0) ? 1 : -1
                      } else {
                        return parseInt(ta[0] | 0) > parseInt(tb[0] | 0) ? 1 : -1
                      }
                    },
                    Cell: row => (
                      <div>서식 {row.value}</div>
                    )
                  },
                  {
                    id: '평가도구',
                    Header: "평가도구",
                    accessor: d => d.data().평가도구
                  },
                  {
                    id: "평가대상",
                    Header: "평가대상",
                    accessor: d => d.data().평가대상
                  },
                  {
                    id: "평가시점",
                    Header: "평가시점",
                    accessor: d => d.data().평가시점
                  }
                ]}
                getTrProps={(state, rowInfo) => {
                  if (rowInfo && rowInfo.row) {
                    return {
                      onClick: e => {
                        const form = rowInfo.original.data();
                        if (form.sku === 'form02_04') {
                          this.setState({
                            alert: (
                              <SweetAlert
                                style={{ display: "block", marginTop: "-100px" }}
                                title="서식 2-4는 서식2-3에서 검사가 진행 된 결과에 대한 '인지기능 영역별 기록지'입니다. 서식2-4 '인지기능 영역별 기록지'는 대상자프로파일에서 확인 가능합니다"
                                onConfirm={() => {
                                  this.setState({
                                    alert: null
                                  })
                                }}
                                confirmBtnCssClass={
                                  this.props.classes.button + " " + this.props.classes.success
                                }
                                cancelBtnCssClass={
                                  this.props.classes.button + " " + this.props.classes.danger
                                }
                                confirmBtnText="확인"
                              />
                            )
                          })
                          return;
                        }

                        if (form.sku === 'form04') {
                          this.setState({
                            alert: (
                              <SweetAlert
                                style={{ display: "block", marginTop: "-100px" }}
                                title="서식 4는 서식2 전체의 결과에 대한 종합적인 결과평가 및 계획을 위한 양식지입니다. 대상자프로파일에서 확인 가능합니다"
                                onConfirm={() => {
                                  this.setState({
                                    alert: null
                                  })
                                }}
                                confirmBtnCssClass={
                                  this.props.classes.button + " " + this.props.classes.success
                                }
                                cancelBtnCssClass={
                                  this.props.classes.button + " " + this.props.classes.danger
                                }
                                confirmBtnText="확인"
                              />
                            )
                          })
                          return;
                        }

                        this.props.setCurrentForm(form);
                        this.props.history.push('/admin/wizard', { sku: form.sku });
                      },
                      style: {
                        cursor: 'pointer'
                      }
                      // style: {
                      //   background:
                      //     rowInfo.index === this.state.rowEdit ? "#00afec" : "white",
                      //   color:
                      //     rowInfo.index === this.state.rowEdit ? "white" : "black"
                      // }
                    };
                  } else {
                    return {};
                  }
                }}
              />
            </CardBody>
          </Card>
        </GridItem>
        {this.state.alert}
      </GridContainer>
    )
  }
}

FormManager.propTypes = {
  classes: PropTypes.object
};

const mapStateToProps = (state) => {
  return {
    forms: state.form.forms
  }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(actions, dispatch);
}


export default compose(
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps)
)(FormManager);